import { Timer } from '@mui/icons-material';
import { IconButton } from '@mui/material';

import {
  AppParts,
  useCanView,
  useModuleRights,
  useNavigate,
} from '@work4all/data';

import { ModuleAccessRightDenyReason } from '@work4all/models/lib/Enums/ModuleAccessRightDenyReason.enum';
import { ModuleAccessRightType } from '@work4all/models/lib/Enums/ModuleAccessRightType.enum';

import { TimeTrackerMenuTabs } from './TimeTrackerMenuTabs';
import { useTimeTracker } from './use-time-tracker';
import { WorkHoursButton } from './WorkHoursButton';

export class TimeTrackerProps {
  className?: string;
}

export function TimeTracker(props: TimeTrackerProps) {
  const navigate = useNavigate();
  const canViewWorkTimeTracking = useCanView(AppParts.WORKTIMETRACKING);
  const canViewProjectTimeTracking = useCanView(AppParts.PROJECTTIMETRACKING);

  const tracker = useTimeTracker({
    disabled: !canViewWorkTimeTracking,
    amplitudeEntryPoint: 'NavigationBar',
  });

  const { rights } = useModuleRights();
  const right = rights.find(
    (right) => right.type === ModuleAccessRightType.FEATURE_WORK_TIME_TRACKING
  );

  if (!tracker.result) {
    return null;
  }

  if (
    canViewWorkTimeTracking ||
    right?.moduleAccessRightDenyReason ===
      ModuleAccessRightDenyReason.NOT_CONFIGURED
  ) {
    return (
      <WorkHoursButton
        tracker={tracker}
        onClick={() =>
          navigate(`/more/timetracking?tab=${TimeTrackerMenuTabs.workingTime}`)
        }
        className={props.className}
      />
    );
  }

  if (canViewProjectTimeTracking) {
    return (
      <IconButton
        onClick={() =>
          navigate(`/more/timetracking?tab=${TimeTrackerMenuTabs.projectTime}`)
        }
      >
        <Timer
          sx={{
            color: 'white',
          }}
        />
      </IconButton>
    );
  }

  return null;
}
